var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.value))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }